<template>
  <div class="button-wrapper">
    <Button :primary="true" @click="handleButtonApprove" xs>Onayla</Button>
    <Button :secondary="true" @click="handleButtonDelete" xs>Ürünü Sil</Button>
  </div>
</template>

<script setup>
import { Button } from "@n11/so-ui-components";
import { ToastMessageTypes } from "@/utils/enum/toastMessageTypes";
import { useStore } from "vuex";

const store = useStore();
const emit = defineEmits([
  "successChangeApproveStatus",
  "successDeleteProduct",
]);

const props = defineProps({
  pid: {
    type: String,
    required: true,
  },
  refreshCallback: {
    type: Function,
    required: true,
  },
});

const messageType = (data) => {
  const hasFailed = data?.failProductIds?.length > 0;
  const hasSucceeded = data?.successProductIds?.length > 0;

  if (hasFailed && hasSucceeded) {
    return {
      fail: ToastMessageTypes.ERROR,
      success: ToastMessageTypes.SUCCESS,
    };
  }
  if (hasFailed) {
    return ToastMessageTypes.ERROR;
  }
  if (hasSucceeded) {
    return ToastMessageTypes.SUCCESS;
  }
  return false;
};

const handleButtonApprove = async () => {
  if (!props.pid) return;
  const payload = {
    productIds: [props.pid],
    productStatus: "Active",
    tabParam: "pending_actions",
  };
  try {
    const res = await store.dispatch(
      "products/changeProductsApproveStatus",
      payload
    );
    const result = messageType(res.data);
    if (result !== false) {
      props.refreshCallback();
      if (typeof result === "object") {
        store.commit("common/SET_TOASTER_DATA", {
          type: result.success,
          description: "İşleminiz onaylandı, ürününüz satışa açıldı.",
        });
        await new Promise((resolve) => setTimeout(resolve, 500));
        store.commit("common/SET_TOASTER_DATA", {
          type: result.fail,
          description: res.data.message,
        });
      } else {
        store.commit("common/SET_TOASTER_DATA", {
          type: result,
          description: "İşleminiz onaylandı, ürününüz satışa açıldı.",
        });
      }
    }
  } catch (error) {
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      title: ToastMessageTypes.ERROR_TITLE,
      description: ToastMessageTypes.ERROR_APPROVAL_STATUS_DESCRIPTION,
    });
  }
};

const handleButtonDelete = async () => {
  if (!props.pid) return;
  const payload = {
    productIds: [props.pid],
    tabParam: "pending_actions",
  };
  try {
    const res = await store.dispatch("products/deleteProducts", payload);
    store.commit("common/SET_TOASTER_DATA", {
      type: messageType(res.data),
      description: "İlgili ürün satışa açılmadan silindi.",
    });
    props.refreshCallback();
  } catch (error) {
    store.commit("common/SET_TOASTER_DATA", {
      type: ToastMessageTypes.ERROR,
      title: ToastMessageTypes.ERROR_TITLE,
      description: ToastMessageTypes.ERROR_DELETE_DESCRIPTION,
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.button-wrapper {
  width: 80px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > button {
    max-height: 24px;
  }
}

:deep(.centered-modal) {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
